<template>
  <v-card color="grey lighten-3" class="pa-2 mb-3">
    <v-card-title>
      <h4 class="subheading my-0">Datos de la jornada laboral</h4>
    </v-card-title>
    <v-layout wrap>
      <v-flex xs6 pr-3>
        <v-select
          v-model="formData.jornada_laboral"
          :disabled="disabled"
          @input="$emit('input', formData)"
          :label="$t('Jornada Laboral')"
          :items="tiposDeJornadaLaboral"
          :rules="[rules.required]"
          required
          item-text="label"
          item-value="value"
          box
          :menu-props="{
            bottom: true,
            'offset-y': true,
          }"
        ></v-select>
      </v-flex>

      <template v-if="formData.jornada_laboral === 'parcial'">
        <v-flex xs6 pr-3>
          <v-text-field
            v-model="formData.jornada_laboral_horas_semanales"
            :disabled="disabled"
            :label="$t('Total horas semanales')"
            :rules="[rules.required]"
            required
            type="number"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs12 pr-3>
          <v-textarea
            v-model="formData.jornada_laboral_horario"
            :disabled="disabled"
            :label="$t('Horario de trabajo semanal')"
            :rules="[rules.required]"
            required
            box
          ></v-textarea>
        </v-flex>
      </template>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          jornada_laboral: null,
          jornada_laboral_horas_semanales: null,
          jornada_laboral_horario: null,
        };
      },
    },
  },
  data() {
    return {
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      tiposDeJornadaLaboral: [
        { label: 'Jornada completa', value: 'completa' },
        { label: 'Jornada parcial', value: 'parcial' },
      ],
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
